import React, {useState} from 'react';

export default function FormContactUs() {
    const [formData, setFormData] = useState({name: '', email: '', message: ''});
    const [status, setStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        setStatus(null);
        try {
            const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
            const res = await fetch(`${backendUrl}/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            if (res.ok) {
                setStatus('success');
                setFormData({name: '', email: '', message: ''});
            } else {
                setStatus('error');
            }
        } catch (err) {
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return(
        <div className="w-full md:w-1/2 px-8 rounded-2xl shadow-md space-y-6 sm:-mt-24">
            <form onSubmit={handleSubmit} className="space-y-6 bg-gradient-to-tr from-black/60 via-black/40 to-black/10">
                {/* Name / Company */}
                <div>
                    <label className="block sm:text-2xl font-semibold  mb-2">
                        <span className="text-white">Name/</span><span className="text-yellow-400">Company</span>
                    </label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter your name / company"
                        className="w-full text-gray-900 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                {/* Email */}
                <div>
                    <label className="block sm:text-2xl font-semibold  mb-2">
                        <span className="text-white">Email</span><span className="text-yellow-400">*</span>
                    </label>
                    <input
                        type="email"
                        name="email"
                        placeholder="Enter your email address"
                        className="w-full text-gray-900 p-4 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:text-black"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                {/* Message */}
                <div>
                    <label className="block sm:text-2xl font-semibold mb-2">
                        <span className="text-white">Message</span><span className="text-yellow-400">*</span>
                    </label>
                    <textarea
                        rows="4"
                        name="message"
                        placeholder="Enter your message"
                        className="w-full text-gray-900 p-4 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-400"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                {/* Submit Button */}
                <div className="flex flex-wrap justify-center sm:justify-start">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`bg-yellow-500 text-white font-semibold py-3 px-6 rounded-full flex items-center gap-2 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-orange-400'}`}
                    >
                        {isSubmitting ? 'Sending...' : 'Send message'}
                        {!isSubmitting && (
                            <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                                />
                            </svg>
                        )}
                    </button>
                </div>
                {status === 'success' && (
                    <p className="text-green-500">Message sent!</p>
                )}
                {status === 'error' && (
                    <p className="text-red-500">Failed to send message.</p>
                )}
            </form>
        </div>
    );
}
